var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppointmentFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9C2 7.11438 2 6.17157 2.58579 5.58579C3.17157 5 4.11438 5 6 5H18C19.8856 5 20.8284 5 21.4142 5.58579C22 6.17157 22 7.11438 22 9C22 9.4714 22 9.70711 21.8536 9.85355C21.7071 10 21.4714 10 21 10H3C2.5286 10 2.29289 10 2.14645 9.85355C2 9.70711 2 9.4714 2 9Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 17C2 18.8856 2 19.8284 2.58579 20.4142C3.17157 21 4.11438 21 6 21H18C19.8856 21 20.8284 21 21.4142 20.4142C22 19.8284 22 18.8856 22 17V12C22 11.5286 22 11.2929 21.8536 11.1464C21.7071 11 21.4714 11 21 11H3C2.5286 11 2.29289 11 2.14645 11.1464C2 11.2929 2 11.5286 2 12V17ZM7 14C7 13.5286 7 13.2929 7.14645 13.1464C7.29289 13 7.5286 13 8 13H10C10.4714 13 10.7071 13 10.8536 13.1464C11 13.2929 11 13.5286 11 14C11 14.4714 11 14.7071 10.8536 14.8536C10.7071 15 10.4714 15 10 15H8C7.5286 15 7.29289 15 7.14645 14.8536C7 14.7071 7 14.4714 7 14ZM7.14645 17.1464C7 17.2929 7 17.5286 7 18C7 18.4714 7 18.7071 7.14645 18.8536C7.29289 19 7.5286 19 8 19H10C10.4714 19 10.7071 19 10.8536 18.8536C11 18.7071 11 18.4714 11 18C11 17.5286 11 17.2929 10.8536 17.1464C10.7071 17 10.4714 17 10 17H8C7.5286 17 7.29289 17 7.14645 17.1464ZM13 14C13 13.5286 13 13.2929 13.1464 13.1464C13.2929 13 13.5286 13 14 13H16C16.4714 13 16.7071 13 16.8536 13.1464C17 13.2929 17 13.5286 17 14C17 14.4714 17 14.7071 16.8536 14.8536C16.7071 15 16.4714 15 16 15H14C13.5286 15 13.2929 15 13.1464 14.8536C13 14.7071 13 14.4714 13 14ZM13.1464 17.1464C13 17.2929 13 17.5286 13 18C13 18.4714 13 18.7071 13.1464 18.8536C13.2929 19 13.5286 19 14 19H16C16.4714 19 16.7071 19 16.8536 18.8536C17 18.7071 17 18.4714 17 18C17 17.5286 17 17.2929 16.8536 17.1464C16.7071 17 16.4714 17 16 17H14C13.5286 17 13.2929 17 13.1464 17.1464Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3L7 6",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 3L17 6",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentFilled);
export default __webpack_public_path__ + "static/media/AppointmentFilled.af5b6e8d.svg";
export { ForwardRef as ReactComponent };